/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionDefinitionVersion extends models.BaseDefinitionVersion {
    getFixupPrototypeFunction() { return DimensionDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<DimensionDefinitionVersion>): DimensionDefinitionVersion {
        let obj = Object.assign(new DimensionDefinitionVersion(), model);
        DimensionDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionDefinitionVersion>): DimensionDefinitionVersion {
        if (!model) return null;
        return DimensionDefinitionVersion.newInstance(<DimensionDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionDefinitionVersion) {
        if (!obj) return;

        models.DimensionDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionDefinitionVersion): boolean {
        if (models.BaseDefinitionVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DimensionDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            models.DimensionDefinitionConfiguration.fixupPrototype(this.details);
        }
    }

    /**
     * Details of the version
     */
    details: models.DimensionDefinitionConfiguration;

}
